import api from "../services/api";

export interface ResponseCartoes {
  cartoes: ICartoes[];
  error: boolean;
  qt: number | 0;
  msg: string | null;
}

export interface ICartoes {
  cliente: string;
  seq: string;
  nome: string;
  plano: string;
  cartao: string;
  bloqueado: string;
  codigo: string;
  cpf: string;
  titular: string;
  tipo: string;
  empresa: string;
  desativado: string;
  dep_maiores: boolean;
  tutelar: string;
  dependentes: IDependentes[];
}

export interface IDependentes {
  nome: string;
  cartao: string;
  bloqueado: string;
  codigo: string;
  desativado: string;
  cpf: string;
  desbloqueia: boolean;
}


export async function cartoes(post: object): Promise<ResponseCartoes> {
  const cartoes = await api
    .post("/beneficiario/cartoes", { bloqueados: 1, ...post })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return {
        error: true,
        msg: error.response.data.error,
      };
    });
  return cartoes;
}


export interface IValidacoesListar {
  codigo: string;
  tipo: string;
}

export interface IValidacoesListarResponse {
  id: string;
  tipo: string;
  texto: string;
  error: string;
  msg: string;
}

export async function validacoesListar(
  post: IValidacoesListar
): Promise<IValidacoesListarResponse> {
  const cartoes = await api
    .post("/validacoes/listar", post)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return {
        error: true,
        msg: error.response.data.error,
      };
    });
  return cartoes;
}


export interface IValidacoesConfirmar {
  codigo: string;
  id: string;
  local: string;
  tipo: string;
  valor: string;
}

export interface IValidacoesConfirmarResponse {
  telefone: string;
  email: string;
  error: string;
  bloqueado: string;
  msg: string;
}

export async function validacoesConfirmar(
  post: IValidacoesConfirmar
): Promise<IValidacoesConfirmarResponse> {
  const cartoes = await api
    .post("/validacoes/validar/beneficiario", post)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return {
        error: true,
        msg: error.response.data.error,
      };
    });
  return cartoes;
}

export interface IEnviarToken {
  novo: string;
  tipo: string;
  codigo: string;
  local: string;
  telefone?: string;
  email?: string;
}

export interface IEnviarTokenResponse {
  error: string;
  msg: string;
}

export async function enviarToken(
  post: IEnviarToken
): Promise<IEnviarTokenResponse> {
  const cartoes = await api
    .post("/token/beneficiario", post)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return {
        error: true,
        msg: error.response.data.error,
      };
    });
  return cartoes;
}


export interface IConfirmarToken {
  codigo: string;
  local: string;
  token: string;
  tipo: string;
}

export interface IConfirmarTokenResponse {
  error: string;
  msg: string;
}

export async function confirmarToken(
  post: IConfirmarToken
): Promise<IConfirmarTokenResponse> {
  const cartoes = await api
    .post("/token/beneficiario/confirmar", post)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return {
        error: true,
        msg: error.response.data.error,
      };
    });
  return cartoes;
}


export interface IDesbloqueio {
  token_email: string | "";
  token_sms: string | "";
  codigo: string | "";
  nomeMae: string | "";
  dataNascimento: string | "";
  sexo: string | "";
  estadoCivil: string | "";
  cep: string | "";
  logradouro: string | "";
  numero: string | "";
  complemento: string | "";
  bairro: string | "";
  cidade: string | "";
  uf: string | "";
  rg: string | "";
  orgaoExpRg: string | "";
  ufEmissorRg: string | "";
  dataExpedicaoRg: string | "";
  telefone: string | "";
  telefone1: string | "";
  telefone2: string | "";
  celular: string | "";
  celular1: string | "";
  celular2: string | "";
  ip: string | "";
  enviar_cartao?: string;
  novo: string;
}

export interface IDesbloqueioResponse {
  error: string;
  msg: string;
  protocolo?: string;
}

export async function desbloqueio(
  post: IDesbloqueio
): Promise<IDesbloqueioResponse> {
  const cartoes = await api
    .post("/beneficiario/desbloqueio", post)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return {
        error: true,
        msg: error.response.data.error,
      };
    });
  return cartoes;
}


export interface IDadosResponse {
  error: string;
  msg: string;
  dados?: {
    a012_nm_usuario: string;
    a012_ddd_celular: string;
    a012_celular: string;
    a012_ddd_celular_sms: string;
    a012_num_celular_sms: string;
    a012_dt_nasc: string;
    a012_dt_expedicao_rg: string;
    a012_nm_mae: string;
    a012_sexo: string;
    a017_cd_estado_civil: string;
    a003_cep_lograd: string;
    a003_nm_lograd: string;
    a003_num_lograd: string;
    a003_compl_lograd: string;
    a904_abrev_bairro: string;
    a902_nm_cidade: string;
    a901_sigla: string;
    a012_rg: string;
    a012_orgao_exped_rg: string;
    uf_expedicao_rg: string;
    a012_ddd_telefone: string;
    a012_telefone: string;
    a012_ddd_telefone_1: string;
    a012_telefone_1: string;
    a012_ddd_telefone_2: string;
    a012_telefone_2: string;
    a012_ddd_celular_1: string;
    a012_celular_1: string;
    a012_ddd_celular_2: string;
    a012_celular_2: string;
    a012_email: string;
    a012_email_1: string;
    a012_email_2: string;
    a003_forma_pagamento: string;
    a003_email_fat: string;
  };
}

export async function dadosCompletos(codigo: string): Promise<IDadosResponse> {
  const cartoes = await api
    .post("/beneficiario/desbloqueio/dados-completos", { codigo })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return {
        error: true,
        msg: error.response.data.error,
      };
    });
  return cartoes;
}

export async function termos(): Promise<string> {
  const cartoes = await api
    .get("beneficiario/desbloqueio/cartao/termos")
    .then((response) => {
      return response.data.texto;
    })
    .catch((error) => {
      return {
        error: true,
        msg: error.response.data.error,
      };
    });
  return cartoes;
}

export async function tokenTextoMensagem(): Promise<string> {
  const cartoes = await api
    .get("beneficiario/desbloqueio/cartao/token-mensagem")
    .then((response) => {
      return response.data.texto;
    })
    .catch((error) => {
      return {
        error: true,
        msg: error.response.data.error,
      };
    });
  return cartoes;
}

export interface ICepResponse {
  logradouro: string;
  bairro: string;
  cep: string;
  cidade: string;
  uf: string;
  geral: string;
  erro: string;
}

export async function buscaCep(cep: string): Promise<ICepResponse> {
  const ec = await api
    .get("cep/buscar/" + cep)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return {
        error: true,
        msg: error.response.data.error,
      };
    });
  return ec;
}

export interface IEstadoCivilResponse {
  dados: object;
  error: string;
  msg: string;
}
export async function estadoCivil(): Promise<IEstadoCivilResponse> {
  const ec = await api
    .get("utilidades/estado-civil")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return {
        error: true,
        msg: error.response.data.error,
      };
    });
  return ec;
}

export interface IOrgaosRgResponse {
  dados: object;
  error: string;
  msg: string;
}
export async function orgaosRg(): Promise<IOrgaosRgResponse> {
  const ec = await api
    .get("utilidades/orgao-expedidor")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return {
        error: true,
        msg: error.response.data.error,
      };
    });
  return ec;
}

export interface IOrgaosRgResponse {
  dados: object;
  error: string;
  msg: string;
}

export async function estados(): Promise<IOrgaosRgResponse> {
  const ec = await api
    .get("utilidades/estados-sio")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return {
        error: true,
        msg: error.response.data.error,
      };
    });
  return ec;
}

export interface enviarCartao {
  codigo: string;
  email: string;
  email_faturamento: string;
}

export interface enviarCartaoResponse {
  error: string;
  msg: string;
}

export async function enviarCartao(
  post: enviarCartao
): Promise<enviarCartaoResponse> {
  const cartoes = await api
    .post("/beneficiario/enviar/cartao", post)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return {
        error: true,
        msg: error.response.data.error,
      };
    });
  return cartoes;
}